var React = require('react');

function WirelessInline (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("path",{"id":"a","d":"M11.971 0L24 7 11.971 19.941 0 8z"})),React.createElement("g",{"fill":"none","fillRule":"evenodd","key":1},[React.createElement("mask",{"id":"b","fill":"#fff","key":0},React.createElement("use",{"xlinkHref":"#a"})),React.createElement("circle",{"cx":"12","cy":"19","r":"7","stroke":"#000","strokeLinecap":"square","strokeLinejoin":"round","strokeWidth":"1.98","mask":"url(#b)","key":1}),React.createElement("circle",{"cx":"12","cy":"18","r":"12","stroke":"#000","strokeLinecap":"square","strokeLinejoin":"round","strokeWidth":"1.98","mask":"url(#b)","key":2}),React.createElement("circle",{"cx":"12","cy":"20","r":"3","fill":"#000","mask":"url(#b)","key":3})])]);
}

WirelessInline.defaultProps = {"viewBox":"0 0 24 24"};

module.exports = WirelessInline;

WirelessInline.default = WirelessInline;
